var _rect, _path, _g, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_929_17)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#AE9142"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_929_17",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 7,
    width: 104,
    height: 104
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0732 106.097C99.0695 106.361 99.0137 106.623 98.909 106.866C98.8043 107.109 98.6527 107.329 98.463 107.513C98.2732 107.698 98.049 107.843 97.8031 107.941C97.5572 108.039 97.2944 108.087 97.0298 108.083H2.97835C2.71351 108.087 2.45047 108.039 2.20426 107.942C1.95805 107.844 1.7335 107.699 1.54348 107.514C1.35345 107.33 1.20166 107.11 1.0968 106.866C0.991932 106.623 0.936054 106.362 0.932351 106.097V103.725C0.885851 103.01 0.790266 99.4447 3.1411 95.5C4.62393 93.0122 6.77585 90.8655 9.53744 89.114C12.8777 86.9956 17.1273 85.4637 22.2681 84.5415C24.8777 84.1742 27.4663 83.6706 30.0233 83.0328C36.8226 81.2968 37.4168 79.7597 37.4219 79.7442C37.4612 79.5924 37.5184 79.4459 37.5924 79.3076C37.6493 79.0235 37.7862 77.9436 37.5227 75.0529C36.8562 67.7085 32.9166 63.3685 29.752 59.881C28.7548 58.783 27.8119 57.742 27.086 56.7241C23.9524 52.3325 23.6631 47.3337 23.6502 47.0237C23.6384 46.4744 23.7142 45.9268 23.8749 45.4014C24.1849 44.4455 24.761 43.8514 25.1847 43.4122C25.2849 43.3117 25.3823 43.2083 25.4766 43.1022C25.5076 43.066 25.5903 42.9679 25.5153 42.4745C25.262 40.8849 25.087 39.2839 24.9909 37.6772C24.8463 35.0887 24.7352 31.2189 25.4043 27.4498C25.5025 26.7299 25.651 26.0177 25.8486 25.3185C26.5538 22.7249 27.6853 20.5084 29.2586 18.6794C29.5298 18.3823 36.1122 11.446 55.2211 10.0252C57.8638 9.82888 60.4756 9.93479 63.0486 10.0665C63.8095 10.0835 64.5668 10.1769 65.309 10.3455C67.2827 10.8545 67.8097 12.1048 67.9466 12.8049C68.1765 13.9674 67.7735 14.8664 67.5074 15.4657C67.4687 15.551 67.4196 15.6569 67.5048 15.9359C67.9466 16.623 68.6467 17.243 69.3571 17.8295C69.5638 18.0025 74.3533 22.1359 74.6168 27.5325C75.3272 31.6374 75.2755 38.0311 74.4359 42.4512C74.3843 42.6966 74.3145 43.0583 74.4308 43.3037C75.3349 44.1123 76.3579 45.0294 76.3553 47.1219C76.345 47.3337 76.0531 52.3299 72.9195 56.7241C72.1962 57.742 71.2533 58.7805 70.2587 59.8784L70.2535 59.881C67.0889 63.3685 63.1494 67.7085 62.4829 75.0503C62.2219 77.9436 62.3588 79.0209 62.4131 79.3076C62.4881 79.4457 62.5462 79.5923 62.5862 79.7442C62.5888 79.7597 63.1803 81.2916 69.9487 83.025C73.8547 84.0248 77.6987 84.5363 77.8149 84.5492C82.8111 85.394 87.0349 86.8897 90.3699 88.9951C93.1212 90.7337 95.2783 92.8882 96.7766 95.394C99.1739 99.3982 99.1094 103.046 99.0758 103.712V106.097H99.0732Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_929_17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68C7.08 68 -8 85.25 -8 96.75V114H108V96.75C108 85.25 92.92 68 50 68Z",
    fill: "#0C2340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0004 61.9998C64.415 61.9998 76.1004 50.3144 76.1004 35.8998C76.1004 21.4852 64.415 9.7998 50.0004 9.7998C35.5858 9.7998 23.9004 21.4852 23.9004 35.8998C23.9004 50.3144 35.5858 61.9998 50.0004 61.9998Z",
    fill: "#0C2340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_929_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.4ccafcf5650f508bbc0a93711aee8f64.svg";
export { ForwardRef as ReactComponent };